import React from 'react';

import OrderCardFormSigningResultContainer from '@components/order-card-form/order-card-form-signing-result-container/OrderCardFormSigningResultContainer';

const OrderCardSigningResultPage = () => <OrderCardFormSigningResultContainer />;

export default OrderCardSigningResultPage;
